export default !!navigator.platform && /iPad|iPhone|iPod|Android|Linux/.test(navigator.platform);
